<div class="h-full bg-white overflow-y-auto">

  <!-- Action Bar (hidden in inline/panel mode) -->
  <div *ngIf="!inlineMode" class="flex items-center gap-2.5 py-4 px-7 border-b border-[var(--app-base)]">
    <button (click)="openBackDialog()"
      class="py-1.5 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-[12px] font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span class="material-icons text-[16px]">arrow_back</span> BACK
    </button>

    <div class="flex flex-col ml-4">
      <div class="flex items-baseline gap-2">
        <span class="text-[16px] font-bold text-[var(--base-text-dark)]">Field Name:</span>
        <span class="text-[15px] font-medium text-[var(--base-text-alt-dark)]">{{seasonFormData ? seasonFormData.field.name : placeholder}}</span>
      </div>
      <div class="flex items-center gap-1 text-[12px] text-[var(--base-text-alt-dark)]">
        <span class="font-bold">Farm Name:</span>
        <span>{{seasonFormData ? seasonFormData.field.farmName : placeholder}}</span>
        <span class="mx-1.5 text-[var(--app-border)]">|</span>
        <span class="font-bold">Country:</span>
        <span>{{seasonFormData ? seasonFormData.field.country : placeholder}}</span>
      </div>
    </div>

    <div class="flex-1"></div>

    <button (click)="openSaveLinkFieldDetailsDialog()"
      class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--primary-dark)] text-white cursor-pointer hover:opacity-90 transition-all">
      SAVE
    </button>
  </div>

  <!-- Linked Season -->
  <div class="px-7 py-4">
    <app-season-field-details
      *ngIf="seasonFormData && seasons"
      [seasons]="seasons"
      [fieldAdminStyle]="fieldAdminStyle"
      [hideSeasonDetails]="inlineMode"
      (emitNewSeason)="populateSeasonDropdownDetails()"
      (emitDataRefresh)="refreshBrowser()"
      [seasonFormData]="seasonFormData"
      [fieldId]="fieldId">
    </app-season-field-details>
  </div>

  <!-- Field Details Header -->
  <div class="px-7 mb-2">
    <p class="text-[14px] font-bold text-[var(--base-text-alt-dark)] mb-1">Field Details</p>
    <p class="text-[12px] text-[var(--tertiary-text)]">To edit field data, assign field to a season, alternatively go to "Field View" under "Map Analysis"</p>
  </div>

  <!-- Definition Tabs -->
  <div *ngIf="seasonFormData?.details?.length > 0" class="px-7 mb-3">
    <div class="flex items-center gap-2 mb-2">
      <span class="text-[13px] font-bold text-[var(--primary-dark)]">Crop Definitions</span>
      <span class="material-icons text-[20px] text-[var(--primary-dark)] cursor-pointer hover:opacity-70"
        [class.opacity-40]="!seasonFormData?.field?.isInAnotherActiveSeason || cultivarSizeInvalid"
        [class.pointer-events-none]="!seasonFormData?.field?.isInAnotherActiveSeason || cultivarSizeInvalid"
        [title]="cultivarSizeInvalid ? 'Fix the cultivar size before adding a definition' : 'Add Definition'"
        (click)="addDefinition()">add_circle</span>
    </div>
    <mat-tab-group [(selectedIndex)]="selectedDefinitionIndex" (selectedIndexChange)="onDefinitionTabChange($event)">
      <mat-tab *ngFor="let def of seasonFormData.details; let i = index"
        [disabled]="cultivarSizeInvalid && i !== selectedDefinitionIndex">
        <ng-template mat-tab-label>
          <div class="def-tab-label flex items-center justify-between w-full min-w-[140px]">
            <span class="text-[12px]">{{ getDefinitionLabel(def, i) }}</span>
            <div *ngIf="seasonFormData.details.length > 1 && seasonFormData?.field?.isInAnotherActiveSeason" class="flex items-center justify-end pl-3">
              <span class="def-tab-close material-icons text-[11px] text-[var(--notification-error)] cursor-pointer opacity-0 transition-opacity"
                (click)="deleteDefinition(def, $event)">close</span>
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- Field Input Form -->
  <div class="px-7 pb-6">
    <app-season-field-input *ngIf="isCallDone"
      [sharedExtraDetailData]="seasonFormExtraData"
      [inputData]="seasonFormData.details[selectedDefinitionIndex]"
      [siblingDefinitions]="seasonFormData.details"
      [serverCultivarSizeError]="cultivarSizeServerError"
      [isInAnotherActiveSeason]="seasonFormData?.field?.isInAnotherActiveSeason"
      [compactMode]="inlineMode"
      [panelTab]="panelTab"
      (formDataChange)="onFormDataChange($event)">
    </app-season-field-input>
  </div>

</div>
